// `.env.ts` is generated by the `npm run env` command
import env from './.env';

export const environment = {
  production: true,
  version: env.npm_package_version,
  defaultLanguage: 'en-US',
  supportedLanguages: [
    'th-TH',
    'en-US'
  ],
  //apiPort: "444/ApiGateway/customApi",
  apiPort: "443",
  apiPath: "/ApiGateway/customApi",
  AcceptUploadFileExtension: ".jpg, .jpeg, .png, .pdf",
  apiProtocol: "https:",
  MaxFileSize: 10,
  keySize: 128
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts